<template>
  <v-list-item two-line>
    <v-list-item-content>
      <v-row class="d-flex">
        <v-col sm="4">
          <p class="listItemLabel mb-2">Nome</p>
          <p class="listItem">{{ name }}</p>
        </v-col>
        <v-col sm="4">
          <p class="listItemLabel mb-2">E-mail</p>
          <p class="listItem">{{ email }}</p>
        </v-col>
        <v-col sm="2">
          <p class="listItemLabel mb-2">Telefone</p>
          <p class="listItem">{{ phone }}</p>
        </v-col>
        <v-col sm="2">
          <p class="listItemLabel mb-2">Mais</p>
          <div>
            <EditAdminButton
              :id="id"
              :name.sync="name"
              :email.sync="email"
              :phone.sync="phone"
            />
            <DeleteAdminButton :id="id" />
          </div>
        </v-col>
      </v-row>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import EditAdminButton from "@/components/other/Modals/edit-admin-modal";
import DeleteAdminButton from "@/components/other/Modals/delete-admin-modal";

export default {
  components: {
    EditAdminButton,
    DeleteAdminButton
  },
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    },
    phone: {
      type: [String, Number],
      required: true
    }
  }
};
</script>

<style scoped>
.listItemLabel {
  padding: 0px;
  margin: 0px;
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.32px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #9e9e9e;
}

.listItem {
  padding: 0px;
  margin: 0px;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #424242;
}
</style>